import { types } from "mobx-state-tree";
import WorkoutContentStore from "stores/WorkoutContentStore";
import {
  PERMISSION_TYPE,
  PUBLISH_STATUS,
  STRUCTURE_TYPE,
} from "constants/common";
import { ImageSize } from "models";

export const Standard = types.model("Standard", {
  all: types.late(() => WorkoutContentStore),
});

export const Week = types.model("Week", {
  monday: types.late(() => WorkoutContentStore),
  tuesday: types.late(() => WorkoutContentStore),
  wednesday: types.late(() => WorkoutContentStore),
  thursday: types.late(() => WorkoutContentStore),
  friday: types.late(() => WorkoutContentStore),
  saturday: types.late(() => WorkoutContentStore),
  sunday: types.late(() => WorkoutContentStore),
});

export const Category = types
  .model("Category", {
    id: types.number,
    title: types.maybe(types.string),
    subTitle: types.maybeNull(types.string),
    imageUrl: types.maybe(types.string),
    cardImageUrl: types.maybeNull(types.string),
    startDate: types.maybeNull(types.string),
    structureType: types.maybe(types.string),
    week: types.maybe(Week),
    standard: types.maybe(Standard),
    permission: types.maybe(types.string),
    publishStatus: types.maybe(types.string),
    images: types.array(ImageSize),
    familyId: types.maybe(types.number),
  })
  .views(self => ({
    get isWeekStructure() {
      return self.structureType === STRUCTURE_TYPE.WEEK;
    },
    get isPermissionPreview() {
      return self.permission === PERMISSION_TYPE.PREVIEW;
    },
    get isPublishStatusPreview() {
      return self.publishStatus === PUBLISH_STATUS.PREVIEW;
    },
  }));

export const Family = types.model("Family", {
  id: types.number,
  title: types.maybe(types.string),
  structureType: types.maybe(types.string),
  workoutsCategories: types.array(Category),
});
